var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import './LoginOrchestration.scss';
import { LoginConsole } from '@idp/login-ui/components';
var LoginOrchestration = /** @class */ (function (_super) {
    __extends(LoginOrchestration, _super);
    function LoginOrchestration(props) {
        return _super.call(this, props) || this;
    }
    LoginOrchestration.prototype.render = function () {
        var _this = this;
        return (React.createElement(LoginConsole, { data: { fullFlow: true, intent: this.props.data.intent, returnUrl: location.href }, events: {
                isAuthenticated: function (authenticated, cancelled) {
                    _this.props.events.isAuthenticated(authenticated, cancelled);
                },
            }, options: { pageLoadEvent: true } }));
    };
    return LoginOrchestration;
}(React.Component));
export default LoginOrchestration;
//# sourceMappingURL=LoginOrchestration.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/LoginOrchestration/LoginOrchestration.js
// module id = 1479
// module chunks = 8